import { InputValidator } from './InputValidator'

export abstract class NumericValidator implements InputValidator {
    isValid = (value: unknown) => {
        if (value === undefined) return true
        if (value === '') return true

        if (typeof value !== 'number') return false
        if (isNaN(value as number)) return false

        return this.isValidNumber(value as number)
    }

    abstract isValidNumber(value: number): boolean
    abstract getMessage(): string
}
